import { SearchOutlined } from "@ant-design/icons"
import { Input } from "antd"
import React, { type ComponentProps } from "react"

import { useDebouncedCallback } from "../../hooks/use-debounced-callback.ts"
import { SEARCH_DEBOUNCE_MS } from "./search-debounce.ts"

interface SearchBarProps extends ComponentProps<typeof Input> {
  onSearch?: (value: string | null) => void
}

export const SearchBar = React.memo(
  ({
    onSearch,
    placeholder,
    defaultValue,
    style = {},
    ...props
  }: SearchBarProps) => {
    const debounced = useDebouncedCallback((search: string) => {
      onSearch?.(search || null)
    }, SEARCH_DEBOUNCE_MS)

    return (
      <Input
        placeholder={placeholder}
        prefix={<SearchOutlined />}
        defaultValue={defaultValue}
        onChange={(e) => debounced(e.target.value)}
        style={{ flex: 1, minWidth: 200, ...style }}
        allowClear
        {...props}
      />
    )
  }
)

SearchBar.displayName = "SearchBar"
